'use strict'

module.exports = {
  SHOULD_GET_NEXT_DYNAMIC_PAGE_URL: 'SHOULD_GET_NEXT_DYNAMIC_PAGE_URL',
  SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL: 'SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL'
}



// WEBPACK FOOTER //
// ./dynamic-pages/cmdTypes.js